import { render } from "./PopupLoader.vue?vue&type=template&id=43c86b94&scoped=true"
import script from "./PopupLoader.vue?vue&type=script&lang=js"
export * from "./PopupLoader.vue?vue&type=script&lang=js"

import "./PopupLoader.vue?vue&type=style&index=0&id=43c86b94&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c86b94"]])

export default __exports__